import React from 'react';
import './HorizontalMenu.scss';

export const HorizontalMenu = ({ children }) => (
    <div className={'horizontal-menu'}>{children}</div>
);
